import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { MainPage } from '@/pages/MainPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { PaymentIntentProvider } from '@/providers/PaymentIntentProvider';

const router = createBrowserRouter([
  {
    element: <PaymentIntentProvider />,
    children: [
      {
        path: '/',
        element: <MainPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

export const DefaultRouter = (): React.ReactElement => <RouterProvider router={router} />;
